//------------------------------------------------------
//		Indexページに必要なjsをまとめて読み込む
//------------------------------------------------------
global.$ = global.jQuery = require('jquery');

//--------------------------------
//		LazyLoad
//--------------------------------
import "./js/jquery.lazy.js"
 
//--------------------------------
//		ヘッダや基本ルーチン
//--------------------------------
import "./js/tirakita_base_functions.js"

//--------------------------------
//		フローティングカート
//--------------------------------
import "./js/floating_cart.js"

//--------------------------------
//		AjaxSuggest2
//--------------------------------
import "./js/jquery.ajaxSuggest2.js"

//--------------------------------
//	OWLカルーセル	部分						
//--------------------------------
import "../vendor/js/owl/owl-carousel/owl.carousel.js";
  
//--------------------------------
//		OWLカルーセル起動
//--------------------------------
import "./js/index_owl.js"

